import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "activitySelect",
    "otherActivityRow",
    "otherActivityInput",
    "ratingSelect",
    "heartRateInput",
    "borgRatingInput",
    "ratingRow", "hours", "minutes", "hoursHidden", "minutesHidden"
  ]

  connect() {
    // console.log(">>>>>>>>>>Activity Form Controller connected<<<<<<<<<<")
    this.toggleOtherActivity()

    this.ratingRowTarget.classList.add("d-none")
    this.heartRateInputTarget.parentElement.classList.add("d-none")
    this.borgRatingInputTarget.parentElement.classList.add("d-none")

    this.hoursTarget?.addEventListener("input", () => this.validateDuration())
    this.minutesTarget?.addEventListener("input", () => this.validateDuration())
    this.validateDuration()

    // Only show/hide dynamically when the user changes the rating select
    this.ratingSelectTarget.addEventListener("change", () => this.toggleRatingFields())
    this.safeSyncDuration()

    this.enforceRequiredForVisibility()

    this._onSubmit = (e) => {

      this.syncDuration()

      this.enforceRequiredForVisibility()

      const hs = this.hoursHiddenTarget?.value?.trim()
      const ms = this.minutesHiddenTarget?.value?.trim()
      if (!hs && !ms) {
        // Manually force a validation error by focusing a visible control
        this.hoursTarget?.setCustomValidity("Please enter duration (hours or minutes)")
        this.element.closest("form").reportValidity()
        this.hoursTarget?.addEventListener("input", () => this.hoursTarget.setCustomValidity(""), { once: true })
        e.preventDefault()
        return
      }

      if (!this.validateDuration()) {
        e.preventDefault()
        this.hoursTarget?.reportValidity()
        this.hoursTarget?.focus()
        return
      }

      if (!this.element.closest("form").checkValidity()) {
        e.preventDefault()
        this.element.closest("form").reportValidity()
      }
    }
    this.element.closest("form")?.addEventListener("submit", this._onSubmit)

  }

  safeSyncDuration() { this.syncDuration() }

  syncDuration() {
    const h = this.hasHoursTarget ? this.hoursTarget.value.trim() : ""
    const m = this.hasMinutesTarget ? this.minutesTarget.value.trim() : ""
    if (this.hasHoursHiddenTarget)   this.hoursHiddenTarget.value   = h ? `${h} hr`  : ""
    if (this.hasMinutesHiddenTarget) this.minutesHiddenTarget.value = m ? `${m} min` : ""
  }

  toggleOtherActivity() {
    const selected = Array.from(this.activitySelectTarget.selectedOptions).map(o => o.value)
    if (selected.includes("Other")) {
      this.otherActivityRowTarget.classList.remove("d-none")
      this.otherActivityRowTarget.classList.add("show")
      this.otherActivityInputTarget.disabled = false
    } else {
      this.otherActivityRowTarget.classList.add("d-none")
      this.otherActivityRowTarget.classList.remove("show")
      this.otherActivityInputTarget.disabled = true
    }

    this.enforceRequiredForVisibility()

  }

  toggleRatingFields() {
    const selected = this.ratingSelectTarget.value
    const showRow = selected === "Heart Rate" || selected === "Borg Rating"

    // Always hide both first
    this.heartRateInputTarget.parentElement.classList.add("d-none")
    this.borgRatingInputTarget.parentElement.classList.add("d-none")

    if (showRow) {
      this.ratingRowTarget.classList.remove("d-none")
      this.ratingRowTarget.classList.add("show")

      if (selected === "Heart Rate") {
        this.heartRateInputTarget.parentElement.classList.remove("d-none")
        this.heartRateInputTarget.disabled = false
        this.heartRateInputTarget.required = true
      } else if (selected === "Borg Rating") {
        this.borgRatingInputTarget.parentElement.classList.remove("d-none")
        this.borgRatingInputTarget.disabled = false
        this.borgRatingInputTarget.required = true
      }
    } else {
      this.ratingRowTarget.classList.add("d-none")
      this.ratingRowTarget.classList.remove("show")
    }

    this.enforceRequiredForVisibility()

  }

  enforceRequiredForVisibility() {

    this.element.querySelectorAll(".d-none input, .d-none select, .d-none textarea").forEach(el => {
      el.required = false
      el.disabled = true
    })

    this.element.querySelectorAll("input, select").forEach(el => {
      if (el === this.hoursTarget || el === this.minutesTarget) return
      // skip non-submittable controls
      const isHiddenType = el.type === "hidden"
      const hasName = !!el.name
      const isDisabled = el.disabled
      const isVisiblyHidden = el.closest(".d-none") !== null

      if (!isHiddenType && hasName && !isDisabled && !isVisiblyHidden) {
        // mark visible, named controls required
        el.required = true
      } else {
        el.required = false
      }
    })
  }

  validateDuration() {
    const h = (this.hoursTarget?.value ?? "").trim()
    const m = (this.minutesTarget?.value ?? "").trim()

    this.hoursTarget?.setCustomValidity("")
    this.minutesTarget?.setCustomValidity("")

    if (!h && !m) {
      const msg = "Enter duration in hours and/or minutes"
      this.hoursTarget?.setCustomValidity(msg)
      this.minutesTarget?.setCustomValidity(msg)
      return false
    }

    return true
  }

}
